import { render, staticRenderFns } from "./PaymentsIn.vue?vue&type=template&id=00b38803&scoped=true"
import script from "./PaymentsIn.vue?vue&type=script&lang=js"
export * from "./PaymentsIn.vue?vue&type=script&lang=js"
import style0 from "./PaymentsIn.vue?vue&type=style&index=0&id=00b38803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b38803",
  null
  
)

export default component.exports